import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { useNavigate } from "react-router-dom";
import priceTierService from "../../services/PriceTierService";

export default function PriceTariffsPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);

    const navigate = useNavigate();
    const [priceTiers, setPriceTiers] = useState([]);
    const [loading, setLoading] = useState(true);
    const toast = useRef(null);

    useEffect(() => {
        loadPriceTiers();
    }, []);

    const loadPriceTiers = async () => {
        try {
            setLoading(true);
            const res = await priceTierService.getAll();
            setPriceTiers(res.data?.data ?? res.data ?? []);
        } catch (error) {
            toast.current?.show({
                severity: "error",
                summary: "Hata",
                detail: "Fiyat listeleri yüklenemedi!",
            });
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (tierId) => {
        try {
            await priceTierService.delete(tierId);
            toast.current?.show({
                severity: "success",
                summary: "Başarılı",
                detail: "Fiyat listesi silindi.",
            });
            loadPriceTiers();
        } catch (error) {
            toast.current?.show({
                severity: "error",
                summary: "Hata",
                detail: "Fiyat listesi silinemedi!",
            });
        }
    };

    const confirmDelete = (event, tierId) => {
        confirmPopup({
            target: event.currentTarget,
            message: "Bu fiyat listesini silmek istediğinize emin misiniz?",
            icon: "pi pi-exclamation-triangle",
            acceptLabel: "Sil",
            rejectLabel: "İptal",
            acceptClassName: "p-button-danger",
            accept: () => handleDelete(tierId),
        });
    };

    const actionsTemplate = (rowData) => (
        <div className="flex gap-2 justify-center">
            <Button
                icon="pi pi-pencil"
                className="w-8 h-8 p-0 border-none bg-emerald-50 text-emerald-600 hover:bg-emerald-100 rounded-lg transition-colors"
                onClick={() => navigate(`/products/price-tiers/edit/${rowData.id}`)}
                tooltip="Düzenle"
            />
            <Button
                icon="pi pi-trash"
                className="w-8 h-8 p-0 border-none bg-red-50 text-red-600 hover:bg-red-100 rounded-lg transition-colors"
                onClick={(e) => confirmDelete(e, rowData.id)}
                tooltip="Sil"
            />
        </div>
    );

    return (
        <div className="p-2 md:p-4 animate-fade-in bg-[#f8fafc] min-h-screen">
            <Toast ref={toast} appendTo={mounted ? document.body : "self"} />
            <ConfirmPopup />

            <div className="bg-white shadow-lg shadow-slate-200/50 border border-slate-200 rounded-2xl overflow-hidden">
                {/* Header Section */}
                <div className="bg-slate-50/50 border-b border-slate-200 p-4 md:p-6 flex flex-col md:flex-row items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                        <div className="!bg-indigo-600 p-3 rounded-xl shadow-md shadow-indigo-500/20">
                            <i className="pi pi-dollar text-white text-xl"></i>
                        </div>
                        <div>
                            <h1 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight">Fiyat Listesi Tanımları</h1>
                            <div className="flex items-center gap-2 mt-0.5">
                                <span className="px-2 py-0.5 bg-indigo-50 text-indigo-600 text-[9px] font-black rounded-lg uppercase border border-indigo-100">Ürünler</span>
                                <span className="text-slate-400 text-xs font-medium">• Müşterilere özel alternatif ürün fiyat listeleri</span>
                            </div>
                        </div>
                    </div>

                    <Button
                        label="YENİ FİYAT LİSTESİ"
                        icon="pi pi-plus"
                        className="!bg-indigo-600 border-none hover:!bg-indigo-700 rounded-xl px-6 py-3 font-black text-sm shadow-lg !shadow-indigo-600/20 transition-all hover:scale-[1.02]"
                        onClick={() => navigate("/products/price-tiers/add")}
                    />
                </div>

                {/* Table Section */}
                <div className="p-4">
                    <DataTable
                        value={priceTiers}
                        paginator
                        rows={10}
                        loading={loading}
                        emptyMessage="Fiyat listesi tanımlanmadı"
                        className="p-datatable-sm"
                        responsiveLayout="scroll"
                        rowHover
                        rowsPerPageOptions={[10, 20, 50]}
                    >
                        <Column
                            field="name"
                            header="FİYAT LİSTESİ ADI"
                            sortable
                            headerClassName="bg-slate-50 text-slate-500 font-black text-[10px] uppercase py-3 px-4"
                            className="py-3 px-4 font-bold text-slate-700"
                        />
                        <Column
                            field="description"
                            header="AÇIKLAMA"
                            headerClassName="bg-slate-50 text-slate-500 font-black text-[10px] uppercase py-3 px-4"
                            className="py-3 px-4 text-slate-600"
                        />
                        <Column
                            header="İŞLEMLER"
                            body={actionsTemplate}
                            headerClassName="bg-slate-50 text-slate-500 font-black text-[10px] uppercase py-3 px-4"
                            style={{ width: "120px", textAlign: "center" }}
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    );
}
